var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.loginUser && _vm.loginUser.uid,
          expression: "loginUser && loginUser.uid"
        }
      ]
    },
    [
      _c("c-header"),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          {
            staticClass: "page-container",
            class: {
              "menu-hide": _vm.menuHide
            }
          },
          [
            _c("c-menu"),
            _vm._v(" "),
            _c("div", { staticClass: "page-content-wrapper" }, [
              _c(
                "div",
                { staticClass: "page-content tab-content" },
                [
                  _c("router-view", {
                    attrs: { transition: "fade", "transition-mode": "out-in" }
                  })
                ],
                1
              )
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("c-select-img-win"),
      _vm._v(" "),
      _c("c-select-video-win"),
      _vm._v(" "),
      _c("c-select-audio-win"),
      _vm._v(" "),
      _c("c-select-article-win"),
      _vm._v(" "),
      _c("c-select-model3d-win"),
      _vm._v(" "),
      _c("c-select-unity3d-win"),
      _vm._v(" "),
      _c("c-player")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }